import React from "react";
import Button from 'antd/lib/button/button';
import styles from './DateTimeInputsRowData.module.css';


type DateTimeInputsRowDataProps = {
  rowIndex: number
  from: string
  to: string
  removeRowHandler?: any
}

const getDateString = (value:string) => {
  if (!value) return value
  const dateString = value.length === 10 
    ? `${value.slice(8, 10)}/${value.slice(5, 7)}/${value.slice(0,4)}`
    : value
  return dateString
}

export const DateTimeInputsRowData: React.FC<DateTimeInputsRowDataProps> = ({ rowIndex, from, to, removeRowHandler }) => (  
  <div className={styles.dateTimeRow}>
    <span className={styles.dateTimeRowDataWrapper}>
      <span>{getDateString(from)}</span>{" "}-{" "}<span>{getDateString(to)}</span>
    </span>
    {removeRowHandler ?
      <Button type='link' onClick={() => removeRowHandler(rowIndex)} className={styles.removeDateTimeBtn}>Remove</Button>
    : null}
  </div>
);

export default DateTimeInputsRowData;
